import React, { Component } from "react";
// import axios from "axios";
import Conf from "../Conf";

class BillPreview extends Component {
  state = {};
  componentDidMount() {
    // var otp = this.props.otp;

    // axios.get(Conf.digitalpayBackend + "bill/file/" + otp).then((res) => {
    //   console.log(res.data);
    // });
    this.setState({ otp: this.props.otp });
  }
  render() {
    const { otp } = this.state;
    const styles = this.props.styles || {
      height: "90vh",
      width: "100%",
    };
    return (
      <div>
        {otp && (
          <>
            <object
              aria-label="pdf"
              // data={Conf.digitalpayBackend + "bill/file/" + otp + "?#view=FitV"}
              data={Conf.digitalpayBackend + "bill/file/" + otp}
              type="application/pdf"
              style={styles}
            ></object>
          </>
        )}
      </div>
    );
  }
}

export default BillPreview;
